var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { GREY_SWEET } from 'ui/constants';
var WithinRow = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: 5px;\n  border-radius: 5px;\n  background-color: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  padding: 5px;\n  border-radius: 5px;\n  background-color: ", ";\n"])), GREY_SWEET);
export default WithinRow;
var templateObject_1;
